import { ApiResponseUserProgressData } from "../types/learning-center-type.types";
import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptedRequest } from "../core/api.client";
export interface IInsertChapterProgressData {
  mobileNo: string;
  product: string;
  level: string;
  moduleName: string;
  gccId: string;
  chapterStatus: string;
  moduleStatus: string;
  levelStatus: string;
}

interface IChaperProgressResponse {
  statusCode: number;
  status: "success" | "error";
  message: string;
}

export interface QuizAnswer {
  questionNo: string;
  userAnswer: string;
}

interface QuizProgress {
  level: "beginner" | "intermediate" | "expert";
  quizData: QuizAnswer[];
}

export interface IInsertQuizProress {
  mobileNo: string;
  product: string;
  quizProgress: QuizProgress[];
}

export interface IGetQuizProgress {
  mobileNo: string;
  product: string;
}

export type IAPIQuizResponse = {
  data: IQuizResponse;
  message: string;
  status: string;
  statusCode: number;
};

interface IQuizResponse {
  status: string;
  status_code: number;
  mobile_no: string;
  product: string;
  quiz_progress_data: QuizProgressResponse[];
}

interface QuizProgressResponse {
  level: "beginner" | "intermediate" | "expert";
  quiz_details: QuizDetail[];
  quiz_score: string;
  quiz_score_percentage: string;
  quiz_status: string;
}

interface QuizDetail {
  question_no: string;
  user_answer: string;
}

export const fetchMasterTrackData = async (trackDataLink: string) => {
  try {
    const response = await fetch(trackDataLink);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const convertedData = await response.json();
    return convertedData;
  } catch (error) {
    logErrorToNewRelic("Error in GetDirection API:", { error: error as string });
  }
};

export const insertChapterProgress = async (
  data: IInsertChapterProgressData
): Promise<IChaperProgressResponse> => {
  try {
    const response = await encryptedRequest<IChaperProgressResponse, IInsertChapterProgressData>({
      method: "POST",
      url: API_PATHS.chapterProgressInsertLc,
      data: { ...data },
    });

    return response;
  } catch (error) {
    logErrorToNewRelic("Error in GetDirection API:", { error: error as string });
    throw error;
  }
};

export const getUserProgressData = async (): Promise<ApiResponseUserProgressData> => {
  try {
    const { mobileNo } = await getSessionData();
    const response = await encryptedRequest<ApiResponseUserProgressData>({
      method: "POST",
      url: API_PATHS.userProgressData,
      data: { mobileNo },
    });

    return response;
  } catch (error) {
    logErrorToNewRelic("Error in GetDirection API:", { error: error as string });
    throw error;
  }
};

export const insertQuizProgress = async (
  data: IInsertQuizProress
): Promise<IChaperProgressResponse> => {
  try {
    const response = await encryptedRequest<IChaperProgressResponse, IInsertQuizProress>({
      method: "POST",
      url: API_PATHS.insertQuizProgressLC,
      data: { ...data },
    });

    return response;
  } catch (error) {
    logErrorToNewRelic("Error in GetDirection API:", { error: error as string });
    throw error;
  }
};

export const getQuizProgress = async (data: IGetQuizProgress): Promise<IAPIQuizResponse> => {
  try {
    const response = await encryptedRequest<IQuizResponse>({
      method: "POST",
      url: API_PATHS.getQuizProgress,
      data: { ...data },
    });

    return response;
  } catch (error) {
    logErrorToNewRelic("Error in GetDirection API:", { error: error as string });
    throw error;
  }
};
